import React from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, BRAND, waLink } from "../lib/constants";

export default function Navbar() {
  const [scrolled, setScrolled] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FAF6F0]/85 backdrop-blur-xl border-b border-[#B5896E]/15"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-brand" className="group flex items-center gap-3">
          <span className="relative inline-block w-9 h-9">
            <span className="absolute inset-0 rounded-full border border-[#B5896E]/60" />
            <span className="absolute inset-[5px] rounded-full bg-gradient-to-br from-[#B5896E] to-[#D4A88E]" />
          </span>
          <span className="font-display text-xl text-[#4A3F35] tracking-wide">
            {BRAND.name}
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm tracking-wide underline-gold ${
                  isActive ? "text-[#B5896E]" : "text-[#4A3F35]/80 hover:text-[#4A3F35]"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a
            data-testid="nav-cta-whatsapp"
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-5 py-2.5 text-xs tracking-[0.2em] uppercase bg-[#B5896E] text-[#FAF6F0] hover:bg-[#D4A88E] transition-colors duration-300 rounded-sm"
          >
            Partner With Us
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-[#4A3F35]"
          onClick={() => setOpen((s) => !s)}
          aria-label="menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#FAF6F0]/95 backdrop-blur-xl border-t border-[#B5896E]/10">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `text-base ${isActive ? "text-[#B5896E]" : "text-[#4A3F35]/85"}`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex items-center justify-center px-5 py-3 text-xs tracking-[0.2em] uppercase bg-[#B5896E] text-[#FAF6F0]"
            >
              Partner With Us
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
